// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__37LBc","info":"PatientInfo_info__f0fsM"};